import React, { useEffect, useState } from 'react'
import { DELETE, GET, PUT } from '../../utils/apicalls';
import { API } from '../../config/api';
import { useNavigate, useParams } from 'react-router-dom';
import { App, Button, Card, Form, Input, Space, Table } from 'antd';

function UpdateCategory() {
    const [isLoading, setIsLoading] = useState(false);
    const [CategoryData, setCategoryData] = useState<any>([]);
    const [allCategoryData, setallCategoryData] = useState<any>([]);
    const [form] = Form.useForm();
    const { notification } = App.useApp(); // Use App context hook to access notification
    const { id } = useParams()
    const navigate = useNavigate();
    const fetchCategory = async () => {
        try {
            setIsLoading(true);
            const response: any = await GET(API.GET_CATEGORY_BY_ID + id, {});
            setCategoryData(response?.data);
            form.setFieldsValue({
                categoryTitle: response?.data?.categoryTitle,
                categoryImage: response?.data?.categoryImage || '', // If categoryImage is optional
            });
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchCategory();
    }, []);

    const submitHandler = async (values: any) => {
        try {
            let obj = {
                categoryTitle: values.categoryTitle,
                categoryImage: "string",
            };

            setIsLoading(true);
            const postRequest = await PUT(API.UPDATE_CATEGORY + id, obj);

            if (postRequest) {
                notification.success({ message: "Category updated successfully!" });
                form.resetFields();
                fetchCategory();
                navigate(-1);
            } else {
                notification.error({ message: "Something went wrong" });
            }
        } catch (error) {
            console.error(error);
            notification.error({
                message: "Something went wrong! Please try again later",
            });
        } finally {
            setIsLoading(false);
        }
    };
    const columns = [
        {
            title: "Index",
            dataIndex: "index",
            render: (_: any, __: any, index: number) => index + 1,
        },
        { title: "categoryTitle", dataIndex: "categoryTitle" },


        {
            title: "Actions",
            key: "actions",
            render: (_: any, record: any) => (
                <Space size="middle">
                    <Button type="link" onClick={() => confirmDelete(record.id)}>Delete</Button>
                    <Button
                        type="link"
                        onClick={() =>
                            navigate(
                                `/Admin/adminCategory/updateCategory/${record.id}`
                            )
                        }
                    >
                        Edit
                    </Button>
                </Space>
            ),
        },
    ];
    const fetachALLCategory = async () => {
        try {
            setIsLoading(true);
            const response: any = await GET(API.GET_ALL_CATEGORIES, {});
            setallCategoryData(response?.data);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetachALLCategory();
    }, []);

    const handleDelete = async (id: any) => {
        try {
            setIsLoading(true);
            const delete_customer_url = `${API.DELETE_CATEGORY}${id}`;
            const data: any = await DELETE(delete_customer_url);

            if (data.status) {
                notification.success({ message: " deleted successfully!" });
                fetachALLCategory();
            } else {
                notification.error({
                    message: "Something went wrong! Please try again later.",
                });
            }
        } catch (error) {
            console.log(error);
            notification.error({
                message: "Something went wrong! Please try again later.",
            });
        } finally {
            setIsLoading(false);
        }
    };

    const confirmDelete = (id: any) => {
        const confirm = window.confirm(
            "Are you sure you want to delete this review?"
        );
        if (confirm) {
            handleDelete(id);
        }
    };
    return (
        <div>
            <h1 className="text-2xl font-bold mb-4">Update Category</h1>
            <Card className="p-4 shadow-md rounded-md">
                <Form
                    form={form}
                    layout="inline"
                    onFinish={submitHandler}
                    className="flex flex-wrap gap-4"
                >
                    <Form.Item
                        label="Category Title"
                        name="categoryTitle"
                        rules={[{ required: true, message: 'Please input the category title!' }]}
                    >
                        <Input placeholder="Enter category title" />
                    </Form.Item>

                    {/* <Form.Item
                            label="Image URL"
                            name="categoryImage"
                        >
                            <Input placeholder="Enter category image URL" />
                        </Form.Item> */}

                    <Form.Item>
                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={isLoading}
                        >
                            {isLoading ? 'Updating...' : 'Update'}
                        </Button>
                    </Form.Item>
                </Form>
            </Card>
            <Card>
                <Table
                    columns={columns}
                    dataSource={allCategoryData}
                    loading={isLoading}
                    rowKey={(record) => record?.id}
                    pagination={{ pageSize: 5 }}
                    scroll={{ x: "max-content" }}
                />
            </Card>
        </div>
    )
}

export default UpdateCategory
